import { hexToRGB } from '@repo-level/core-front';
import { ScAuthButtons } from 'components/auth/AuthButtons/styled';
import { ScPromoDot } from 'components/PromoDot/styled';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components/macro';

interface ScTabBarProps {
  isAuthenticated: boolean;
  isWheelVisible: boolean;
}

export const ScTabBar = styled.div<ScTabBarProps>`
  position: fixed;
  bottom: -2px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 111;
  background: ${({ theme }) => theme.grayColor5};
  box-shadow: 0px -8px 30px 0px ${({ theme }) => hexToRGB(theme.blackColor, 0.6)};
  padding: 8px 16px 16px;

  @media print {
    display: none;
  }

  ${ScAuthButtons} {
    &.fr,
    &.fr-CA {
      button {
        font-size: 80%;
      }
    }
    @media (${device.mobileXS}) {
      &.de {
        button {
          font-size: 80%;
        }
      }

      &.fr,
      &.fr-CA {
        button {
          padding: 0 4px;
          font-size: 70%;
        }
      }
    }
  }

  .main-content {
    position: relative;
    display: grid;
    grid-template-columns: ${({ isAuthenticated }) =>
      isAuthenticated ? 'auto 136px' : '1fr 40px'};
    gap: 8px;
  }

  .menu-list {
    position: relative;
    list-style: none;
    display: grid;
    grid-template-columns: ${({ isAuthenticated, isWheelVisible }) => {
      if (!isAuthenticated) return '1fr 40px 40px';

      let cols = 4;
      if (isWheelVisible) cols++;

      return `repeat(${cols}, 1fr)`;
    }};

    gap: 8px;
    align-items: center;

    & > li {
      display: flex;
      align-items: center;
      justify-content: center;

      & > button {
        position: relative;
        border: none;
        background: none;
        width: 40px;
        height: 40px;

        & > ${ScPromoDot} {
          position: absolute;
          width: 8px;
          height: 8px;
          top: 5px;
          right: 4px;
        }

        & > .wheel-spins {
          position: absolute;
          display: flex;
          width: 18px;
          height: 18px;
          top: 0;
          right: 0;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-weight: 700;
          line-height: 18px;
          color: ${({ theme }) => theme.whiteColor};
          background-image: ${({ theme }) => theme.greenMarineGradient};
          border-radius: 4px;
          border: 2px solid ${({ theme }) => theme.grayColor5};
        }

        & > svg {
          width: 100%;
          height: 100%;
          object-fit: contain;

          path {
            fill: ${({ theme }) => theme.whiteColor};
          }
        }
      }
    }
  }
  @media (max-width: 340px) {
    gap: 4px;

    & > .menu-list {
      gap: 0;
    }
  }
`;

export const ScSlogan = styled.p`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${({ theme }) => theme.grayColor1};
`;
